import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {BehaviorSubject, firstValueFrom, Observable, Subject} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handling.service';
import _ from 'lodash';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class ApplicationService {
  private handleError: HandleError;
  public addressesSubject = new BehaviorSubject(null);
  addresses$ = this.addressesSubject.asObservable();

  public dataChangeSubject = new BehaviorSubject(null);
  dataChange$ = this.dataChangeSubject.asObservable();
  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('ApplicationService');
  }

  public submitApplication(body): Observable<any> {
    httpOptions.headers = httpOptions.headers.set('x-workflow-id', '');
    return this.http
      // .post<any[]>(`${environment.api.submission}/submit`, body, httpOptions)
      .post<any[]>(`${environment.api.submission}/submit?debug=true`, body, httpOptions)
      .pipe(
        catchError(this.handleError('submitApplication', []))
      );
  }

  public submitLead(body): Observable<any> {
    httpOptions.headers = httpOptions.headers.set('x-workflow-id', 'lead-submission');
    return this.http
      .post<any[]>(`${environment.api.submission}/submit?debug=true`, body, httpOptions)
      .pipe(
        catchError(this.handleError('submitLead', []))
      );
  }

  public submitError(body): Observable<any> {
    httpOptions.headers = httpOptions.headers.set('x-workflow-id', 'wizard-error');
    return this.http
      .post<any[]>(`${environment.api.submission}/submit?debug=true`, body, httpOptions)
      .pipe(
        catchError(this.handleError('submitError', []))
      );
  }

  public deleteAttachment(file): Observable<any>  {
    httpOptions.headers = httpOptions.headers.set('x-workflow-id', '');
    return this.http
      .delete<any[]>(`${environment.api.submission}/attachments/${file.checksum}/${file.key}`, httpOptions)
      .pipe(
        catchError(this.handleError('deleteAttachment', []))
      );
  }

  public checkVersion(): Observable<any> {
    return this.http
      .get<any[]>(`${environment.api.submission}/ver`, httpOptions)
      .pipe(
        catchError(this.handleError('checkVersion', []))
      );
  }

  public retrieveApplication(id, mode): any {
    let url;
    if (mode === 'old-personal') {
      url = `${environment.api.submission}/wizard-packet/application/${id.toString()}`;
    } else if (mode === 'limit-increase') {
      url = `${environment.api.submission}/wizard-packet/settlement/${id.toString()}`;
    }
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    return this.http
      .get<any[]>(url, httpOptions)
      .pipe(catchError(this.handleError('retrieveApplication', [])));
  }

  public getBlurb(url) {
    return this.http
      .get(`${url}`, {responseType: 'text'})
      .pipe(
        catchError(this.handleError('getBlurb', []))
      );
  }

  public packetRetrieve(id) {
    return this.http.get(`${environment.api.submission}/packet/retrieve/${id}`, httpOptions);
  }

  public importShapeA(id) {
    return this.http.post(`${environment.api.submission}/import/import/${id}`, {}, httpOptions);
  }

  public validateShapeA(id) {
    return this.http.get(`${environment.api.submission}/import/import/${id}/validate`, httpOptions);
  }

  public getApplicationAddresses(data) {
    this.addressesSubject.next({
      companyList: data['app-company-details'] ? data['app-company-details']['companyList'] : [],
      personList:  data['app-personal-details'] ? data['app-personal-details']['personList'] : [],
      trustList: data['app-trust-details'] ? data['app-trust-details']['trustList'] : []
    });
  }

}
